import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
  fetchPeriodFinancialSheet,
  fetchQuickBudget,
  fetchParameterSettings,
  exportPeriodFinancialSheet
} from "Thunks";
import {
  initPeriodFinancialSheetTree,
  setFinancialSheetTreeBudgetTab,
  setQuickBudgetClient,
  setImportFinancialModal
} from "Actions";
import { TREE_TYPES } from "../../config";
import _ from "i18n";

import { ICONS, SvgIcon } from "../Common/Icons";
import NotFoundV2 from "../NotFound/NotFoundV2";
import PageHeader from "../Common/PageHeader/PageHeader";

import styles from "./PeriodFinancialSheet.local.scss";

import TreeTable from "./TreeTable";
import PeriodFinancialSheetFilter from "./PeriodFinancialSheetFilter";
import BudgetModal from "../Budget/BudgetModal";
import TTPTab from "../Common/TTPTab";
import classNames from "classnames";
import ImportFinancialModal from "./ImportFinancialModal";
import { inIframe } from "../../utils";
import { NotificationBar } from "../Common/Notification/NotificationBar";
import { setFinancialSheetStartPaginationState } from "../../actions/actions/financial-sheet";

const tabs = [
  {
    id: "ANALYSIS",
    label: _("analysis")
  },
  {
    id: "DETAILS",
    label: _("details")
  }
];

class PeriodFinancialSheetTree extends PureComponent {
  intervalID;

  constructor(props) {
    super(props);

    this.state = {
      isUploadModalVisible: false,
      isConfirmationModalVisible: false,
      filterFormIsVisible: false,
      openSideBar: false,
      selectedSideBar: null,
      loading: false,
      isBudgetModalVisible: false
    };
  }

  handleQuickBudgetNext = currentClientId => {
    const { dispatch } = this.props;
    let idx = this.props.financialData.findIndex(
      // eslint-disable-next-line eqeqeq
      item => item.data.id == currentClientId
    );
    if (this.props.financialData[idx + 1]) {
      const { id, year } = this.props.financialData[idx + 1].data;
      dispatch(
        setQuickBudgetClient({
          clientId: id,
          // eslint-disable-next-line radix
          year: parseInt(year) + 1
        })
      );
      dispatch(fetchQuickBudget());
    }
  };

  handleQuickBudgetPrevious = currentClientId => {
    const { dispatch } = this.props;
    let idx = this.props.financialData.findIndex(
      // eslint-disable-next-line eqeqeq
      item => item.data.id == currentClientId
    );
    if (this.props.financialData[idx - 1]) {
      const { id, year } = this.props.financialData[idx - 1].data;
      dispatch(
        setQuickBudgetClient({
          clientId: id,
          // eslint-disable-next-line radix
          year: parseInt(year) + 1,
          suggestionFrom: "time"
        })
      );
      dispatch(fetchQuickBudget());
    }
  };

  handleConfigureQuickBudget = (clientId, year) => {
    const { dispatch } = this.props;
    dispatch(
      setQuickBudgetClient({
        clientId: clientId,
        year: parseInt(year, 10) + 1
      })
    );
    dispatch(fetchQuickBudget());
    // eslint-disable-next-line radix
    dispatch(fetchParameterSettings(parseInt(year) + 1));
  };

  handleConfigureQuickBudgetCurrentYear = (clientId, year) => {
    const { dispatch } = this.props;
    dispatch(
      setQuickBudgetClient({
        clientId: clientId,
        year: parseInt(year, 10)
      })
    );
    dispatch(fetchQuickBudget());
    // eslint-disable-next-line radix
    dispatch(fetchParameterSettings(parseInt(year)));
  };

  handleTablePaginationChange = (startPage, pageSize) => {
    const { dispatch } = this.props;

    dispatch(fetchPeriodFinancialSheet());
  };

  renderFinancialSheet = () => {
    const {
      financialData,
      erpData,
      activeTab,
      parameterSettings,
      totalFinancialData
    } = this.props;
    let dataModel = financialData;

    return dataModel && dataModel.length === 1
      ? this.renderFinancialSheetNotFound(170041)
      : activeTab === tabs[0].id
        ? this.renderAnalysis({
            dataModel,
            erpData,
            parameterSettings,
            totalData: totalFinancialData
          })
        : this.renderDetails({ dataModel, erpData, parameterSettings });
  };

  renderAnalysis = ({ dataModel, erpData, parameterSettings, totalData }) => {
    return (
      <TreeTable
        expandAll={true}
        columns={["budgetH", "budgetEco", "PrestaTs", "profit", "Encours"]}
        dataSource={dataModel}
        totalData={totalData}
        erpData={erpData}
        parameterSettings={parameterSettings}
        onPaginationChange={this.handleTablePaginationChange.bind(this)}
        types={[TREE_TYPES.COLLABORATOR, TREE_TYPES.CLIENT]}
        handleConfigureQuickBudget={this.handleConfigureQuickBudget.bind(this)}
        handleConfigureQuickBudgetCurrentYear={this.handleConfigureQuickBudgetCurrentYear.bind(
          this
        )}
      />
    );
  };

  renderDetails = ({ dataModel, erpData, parameterSettings }) => {
    return (
      <TreeTable
        expandAll={true}
        columns={["profit", "benchmark", "budgetaryBenchmark"]}
        dataSource={dataModel}
        erpData={erpData}
        parameterSettings={parameterSettings}
        types={[TREE_TYPES.COLLABORATOR, TREE_TYPES.CLIENT]}
        handleConfigureQuickBudget={this.handleConfigureQuickBudget.bind(this)}
        handleConfigureQuickBudgetCurrentYear={this.handleConfigureQuickBudgetCurrentYear.bind(
          this
        )}
      />
    );
  };

  renderFinancialSheetCallout = error => {
    if (error.code === 170040) {
      return this.renderFinancialSheetStillInProgress();
    } else {
      return this.renderFinancialSheetNotFound(error.code);
    }
  };

  renderFinancialSheetNotFound = code => {
    switch (code) {
      case 170010:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("noOrganization")}
            buttonIgnored={this.props.embedded}
          />
        );
      case 170040:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("error1")}
            buttonIgnored={this.props.embedded}
          />
        );
      case 170041:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("noFinancialSheetMatches")}
            buttonIgnored={this.props.embedded}
          />
        );

      default:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("errorOccured")}
            buttonIgnored={this.props.embedded}
          />
        );
    }
  };

  renderFinancialSheetStillInProgress = () => {
    this.intervalID = setTimeout(() => {
      if (this.props.fetched) {
        clearTimeout(this.intervalID);
        return;
      }
      !this.props.fetching && this.props.dispatch(fetchPeriodFinancialSheet());
    }, 7000);
    return (
      <div
        data-closable
        className={`callout alert-callout-border primary radius ${
          styles.callout
        }`}
      >
        <strong>
          <span style={{ verticalAlign: "inherit" }}>
            <img src={"/img/Spinner-1s-25px.svg"} alt="" />
          </span>
          Info
        </strong>{" "}
        <span
          dangerouslySetInnerHTML={{
            __html: _("importInProgress")
          }}
        />
        <button
          className="close-button"
          aria-label="Dismiss alert"
          type="button"
          data-close
          onClick={null}
        />
      </div>
    );
  };

  componentDidMount() {
    this.props.dispatch(setFinancialSheetTreeBudgetTab(tabs[0].id));
  }

  componentWillUnmount() {
    clearTimeout(this.intervalID);
    this.props.dispatch(initPeriodFinancialSheetTree());
  }

  handleCloseSideBar = () => {
    this.setState({
      openSideBar: false,
      selectedSideBar: null
    });
  };

  handleFilterFormIsVisible = isVisible => {
    this.setState({ filterFormIsVisible: isVisible });
  };

  selectTab = activeTab => {
    const { dispatch } = this.props;
    dispatch(setFinancialSheetTreeBudgetTab(activeTab));
    dispatch(fetchPeriodFinancialSheet());
  };

  handleExportFinancialSheet = () => {
    const { dispatch } = this.props;
    let { selectedYear } = this.props;

    dispatch(exportPeriodFinancialSheet(selectedYear));
  };

  handleOpenImportFinancialSheetModal = () => {
    const { dispatch } = this.props;
    dispatch(setImportFinancialModal(true));
  };
  renderExportFinancial = () => {
    const { fetched, exportFetching } = this.props;

    if (fetched) {
      return (
        <div
          className="row medium-6"
          style={{
            marginTop: "2%",
            marginRight: "-21%"
          }}
        >
          <div className={"medium-3"}>
            <a
              target="_blank"
              className="btn secondary text-uppercase"
              onClick={this.handleOpenImportFinancialSheetModal}
              style={{ opacity: 0.5 }}
            >
              <SvgIcon icon={ICONS.UPLOAD} />

              {_("Import")}
            </a>
          </div>
          <div
            className={"medium-3"}
            style={{
              marginLeft: "2%"
            }}
          >
            <a
              target="_blank"
              className="btn secondary text-uppercase"
              onClick={this.handleExportFinancialSheet}
            >
              {exportFetching ? (
                <img
                  width={"16%"}
                  src={"/img/icons/tail-spin-blue.svg"}
                  alt={""}
                />
              ) : (
                <img
                  width={"11%"}
                  src={"/img/icons/exportation.svg"}
                  alt={""}
                />
              )}
              {_("Export")}
            </a>
          </div>
        </div>
      );
    }

    return "";
  };

  render() {
    const {
      fetching,
      fetched,
      error,
      activeTab,
      collaborator,
      currentOrganization
    } = this.props;

    return (
      <div>
        {inIframe() === false && (
          <div style={{ marginBottom: "10px" }}>
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        {this.state.openSideBar && <div className={styles.sidebar_mask} />}
        <PageHeader
          header={_("financial-sheet")}
          subHeader={_("subTitleFinancialSheet")}
          icon={ICONS.FINANCIAL_PAGE_ICON}
          customAddOn={this.renderExportFinancial()}
        />
        <div className={styles.resizable}>
          <div>
            <div
              className={classNames(
                "ttp-tab-container",
                styles.financial_sheet_container
              )}
            >
              <TTPTab
                tabs={tabs}
                activeTab={activeTab}
                selectTab={this.selectTab}
              />
              <div className="rmodal__center">
                {collaborator && (
                  <PeriodFinancialSheetFilter
                    filterFormIsVisible={this.handleFilterFormIsVisible}
                    collaborator={collaborator}
                    preferences={
                      currentOrganization["authorisation"] &&
                      currentOrganization["authorisation"].preferences
                    }
                  />
                )}

                {error && this.renderFinancialSheetCallout(error)}

                <div>
                  {fetching ? (
                    <div className={styles.ripple_loading}>
                      <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                    </div>
                  ) : (
                    fetched && this.renderFinancialSheet()
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <BudgetModal
          handleQuickBudgetNext={this.handleQuickBudgetNext.bind(this)}
          handleQuickBudgetPrevious={this.handleQuickBudgetPrevious.bind(this)}
        /> */}
        <ImportFinancialModal />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.financialSheet.periodTree.fetching,
  exportFetching: state.financialSheet.exportFinancialSheet.fetching,
  fetched: state.financialSheet.periodTree.fetched,
  error: state.financialSheet.periodTree.error,
  financialData: state.financialSheet.periodTree.financialSheetData,
  totalFinancialData: state.financialSheet.periodTree.resultCount,
  selectedYear: state.financialSheet.periodFilter.year.selected,
  parameterSettings: state.parameterSettings.data,
  erpData: state.erpData.data,
  currentOrganization: state.auth.currentOrganization,
  collaborator: state.collaborator.collaborator,
  activeTab: state.financialSheet.periodTree.tab
});

export default connect(mapStateToProps)(PeriodFinancialSheetTree);



// WEBPACK FOOTER //
// ./src/components/Financial/PeriodFinancialSheetTree.js